import parse from "html-react-parser";
import { useSelector } from "react-redux";

import { CustomReviewEstimateTable } from "../ReviewEsimateSheetTable";
import { useReviewSheet } from "../ReviewSheetContext";

import footerImg from "@/assets/images/footerImg.png";
import defaultLogo from "@/assets/images/headerImg.png";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { WasteFormat } from "@/interfaces/wastetype.interface";
import { renderFullName } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { dateFormat } from "@/utils/helper-functions/date-time.helper";

export const ReviewEstimationPageTemplate = ({
  letterHead,
}: {
  letterHead: WasteFormat;
}): JSX.Element => {
  return (
    <div>
      {letterHead?.headerActive && (
        <div
          style={{
            width: "100%",
            textAlign: "center",
            position: "absolute",
            top: "0",
            left: "0",
          }}
        >
          <img
            src={letterHead?.headerImage || defaultLogo}
            alt='header'
            style={{
              opacity: letterHead?.headerOpacity,
              width: "100%",
              height: "140px",
              objectFit: "fill",
            }}
          />
        </div>
      )}
      {letterHead?.watermarkActive && letterHead?.watermarkImage && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "100px",
            color: "rgba(0, 0, 0, 0.1)",
            opacity: letterHead?.watermarkOpacity,
          }}
        >
          <img
            src={letterHead?.watermarkImage}
            alt='header'
            style={{
              opacity: letterHead?.watermarkOpacity,
              width: "100%",
              height: "140px",
              objectFit: "fill",
              mixBlendMode: "multiply",
            }}
          />
        </div>
      )}
      <div style={{ position: "absolute", bottom: "0", width: "100%" }}>
        {letterHead?.footerActive && (
          <img
            src={letterHead?.footerImage || footerImg}
            alt='footer'
            style={{
              opacity: letterHead?.footerOpacity,
              width: "100%",
              height: "140px",
              objectFit: "fill",
            }}
          />
        )}
      </div>
    </div>
  );
};

// This component is used for downloading the PDF of the estimate review page
const DownloadPDFEstimateReview = (): JSX.Element => {
  const { originalData, selectedData, itemsList } = useReviewSheet();
  const userData = useSelector((state: RootState) => state.user?.userData);

  return (
    <>
      <div className='px-4 my-20 space-y-3 '>
        <h1 className='text-xl mt-36'>Strip-Out/Demolition Quote</h1>
        <div className='p-2 border rounded-sm '>
          <div className='grid grid-cols-2 '>
            <div>
              <div className=' flex gap-[3.8rem] py-2 border-b'>
                <h1 className='text-sm'>ATTN</h1>
                <p className='text-sm text-gray-400'>
                  {originalData?.lead?.customerUsers?.[0]?.user?.firstName}
                </p>
              </div>
              <div className='flex py-2 border-b  gap-14'>
                <h1 className='text-sm'>Client</h1>
                <p className='text-sm text-gray-400'>
                  {originalData?.lead?.customer?.name}
                </p>
              </div>
              <div className='flex gap-10 py-2 '>
                <h1 className='text-sm'>Address</h1>
                <p className='text-sm text-gray-400'>
                  {originalData?.lead?.address?.areaLocation}
                </p>
              </div>
            </div>
            <div>
              <div className='flex gap-16 py-2 border-b '>
                <h1 className='text-sm'>Our Ref</h1>
                <p className='text-sm text-gray-400'>
                  {originalData?.lead?.referenceNumber}
                </p>
              </div>
              <div className=' flex gap-[5.2rem] py-2 border-b'>
                <h1 className='text-sm'>Date</h1>
                <p className='text-sm text-gray-400'>
                  {dateFormat(originalData?.submittedDate, "dd/MM/yyyy")}
                </p>
              </div>
              <div className=' flex gap-[3.6rem] py-2 '>
                <h1 className='text-sm'>Property</h1>
                <p className='text-sm text-gray-400'>
                  {originalData?.lead?.address?.label}
                </p>
              </div>
            </div>
          </div>
        </div>
        <CustomReviewEstimateTable
          data={selectedData?.mainCost || []}
          itemsList={itemsList}
          isExport
        />
        {selectedData?.additionalCost?.length !== 0 ? (
          <CustomReviewEstimateTable
            data={selectedData?.additionalCost || []}
            itemsList={itemsList}
            isExport
            isOptional
            className='mt-32'
          />
        ) : (
          <Table>
            <TableHeader>
              {Array?.from({ length: 5 }, (_, i) => (
                <TableCell key={i}></TableCell>
              ))}
            </TableHeader>
            <TableBody className='border'>
              <TableRow>
                <TableCell className='border ' colSpan={3}>
                  Additional Option Cost Ex GST
                </TableCell>
                {Array?.from({ length: 4 }, (_, i) => (
                  <TableCell className='border ' key={i}></TableCell>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        )}
      </div>
      <section className='flex items-center mt-3 '>
        <span className='px-3 '>Remarks:</span>
        <div className='flex-col '>{parse(originalData?.review ?? "")}</div>
      </section>
      <div className='flex flex-col gap-1 mt-3 ml-3 '>
        <h2>Your Sincerely,</h2>
        <div>
          <p>
            Name:{" "}
            <span className='text-gray-500'>
              {renderFullName({ userData })}
            </span>
          </p>
          <p>
            Role: <span className='text-gray-500'>{userData?.role}</span>
          </p>
        </div>
      </div>
    </>
  );
};

DownloadPDFEstimateReview.displayName = "DownloadPDFEstimateReview";

export default DownloadPDFEstimateReview;
